import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { FormsModule } from '@angular/forms';
import { AngularFireModule } from 'angularfire2';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { environment } from '../environments/environment';
import { HttpClientModule } from '@angular/common/http';

import { BrowserAnimationBuilder } from '@angular/platform-browser/animations/src/animation_builder';
import { SubscribeResultSuccessComponent } from './components/subscribe-result-success/subscribe-result-success.component';
import { SubscribeResultErrorComponent } from './components/subscribe-result-error/subscribe-result-error.component';
import { RouterModule, Routes } from '@angular/router';
import { NavigationBarDesktopComponent } from './components/navigation-bar-desktop/navigation-bar-desktop.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HomeComponent } from './components/home/home.component';
import { VideoListComponent } from './components/video-list/video-list.component';
import { NavigationBarDesktopSpacerComponent } from './components/navigation-bar-desktop-spacer/navigation-bar-desktop-spacer.component';
import { YouTubeService } from './services/you-tube.service';
import { HttpClient } from '@angular/common/http/src/client';
import { VideoBookComponent } from './components/video-book/video-book.component';
import { VideoBookPageComponent } from './components/video-book-page/video-book-page.component';
import { VideoBookShelfComponent } from './components/video-book-shelf/video-book-shelf.component';
import { VideoBookResolver } from './components/video-book/video-book-resolver';

const appRoutes: Routes = [
  {
    path: 'home',
    component: HomeComponent,
    data: { title: 'Home' }
  },
  {
    path: 'videos/:bookName',
    component: VideoBookComponent,
    resolve: {
      videos: VideoBookResolver
    }
  },
  {
    path: 'videos',
    component: VideoBookShelfComponent,
    data: { title: 'Videos' },
    resolve: {
      videoData: YouTubeService
    }
  },
  { path: '',
    redirectTo: '/home',
    pathMatch: 'full'
  },
  { path: '**',
  redirectTo: '/home',
  pathMatch: 'full'
  }
];

@NgModule({
  declarations: [
    AppComponent,
    SubscribeResultSuccessComponent,
    SubscribeResultErrorComponent,
    NavigationBarDesktopComponent,
    HomeComponent,
    VideoListComponent,
    NavigationBarDesktopSpacerComponent,
    VideoBookComponent,
    VideoBookPageComponent,
    VideoBookShelfComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    NgbModule.forRoot(),
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule.enablePersistence(),
    AngularFireAuthModule,
    RouterModule.forRoot(
      appRoutes,
      { enableTracing: true } // <-- debugging purposes only
    )
  ],
  providers: [ YouTubeService, VideoBookResolver ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts